/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import ScrubberUICss from "./ScrubberUI.css";
import hammer from "hammerjs/hammer";
import { throttle } from "utils/lodashUtils";
import { openPopUP } from "components/common/scrubber/pagePopUp";
import { ScrubberMidDiv } from "components/common/scrubber/ScrubberMidDiv";
import classNames from "classnames";

class ScrubberUI extends React.Component {
  constructor(props) {
    super(props);
  }

  _onRef(handle) {
    if (!this.elementHandle) {
      this.elementHandle = handle;
      this.scrollManager = new hammer.Manager(this.elementHandle);
      this.scrollManager.add(new hammer.Pan({ threshold: 2, pointers: 0 }));
      this.scrollManager.on(
        "pan",
        throttle(event => {
          this.props.scrubberEvent(event);
        }, 100)
      );
    }
  }

  render() {
    let scrubberStyle = {
      top: this.props.scrubberYPos
    };

    let className = ScrubberUICss.ScrubberUI;
    className = classNames(className, ScrubberUICss.ScrubberUIVertical);
    const { currentPageNumber, showScrubberMidDiv, intl } = this.props;

    return this.props.totalPages > 1 ? (
      <div>
        <ScrubberMidDiv pageNumber={currentPageNumber} show={showScrubberMidDiv} intl={intl} />
        <div className={className} style={scrubberStyle} ref={handle => this._onRef(handle)}>
          <div
            className={ScrubberUICss.ScrubberPageNumVertical}
            key={currentPageNumber}
            onClick={() => openPopUP(this.props.totalPages)}
          >
            {currentPageNumber}
          </div>
        </div>
      </div>
    ) : null;
  }
}

export { ScrubberUI };
